<template>
  <div >
      <div v-if ="diplayMode == 'list'"  class="woList">
        <van-nav-bar 
        left-text="返回"
        left-arrow
        @click-left="goToHomePage"
        style="position:fixed;width:100%">
          <template #title>
            <span>我的工单</span>
          </template>
          <template #right>
            <van-icon name="scan" size="24" @click="scan" style="font-size:24px"/>
          </template>
        </van-nav-bar>

        <van-collapse v-model="activeNames" style="padding:60px 20px 0 20px" :border="false">
          <van-collapse-item title="检索条件" name="1">
                <van-cell-group inset>
                  <van-field
                    v-model="queryParams.woId"
                    name="工单编号"
                    label="工单编号"
                    placeholder="工单编号"
                    clearable
                  />

                  <van-field
                    v-model="queryParams.productNo"
                    name="主件品号"
                    label="主件品号"
                    placeholder="主件品号"
                    clearable
                  />

            <van-field name="radio" label="工单状态">
                <template #input>
                  <van-radio-group v-model="queryParams.woStatus" direction="horizontal" style="font-size:10px">
                    <van-radio name="全部">全部</van-radio>
                    <van-radio name="完工">完工</van-radio>
                    <van-radio name="未完工">未完工</van-radio>
                  </van-radio-group>
                </template>
              </van-field>

              <van-field
                  v-model="startDateTimeFormatter"
                  center
                  clearable
                  label="起始日期"
                  placeholder=""
                  @click="$refs.startDateSelectDialog.open(queryParams.startDate)"
                >
                  <template #button>
                    <van-icon name="clear" size="18" @click.stop="queryParams.startDate = ''" style="font-size:16px"/>
                  </template>
                </van-field>
      
                <van-field
                  v-model="endDateTimeFormatter"
                  center
                  clearable
                  label="结束日期"
                  placeholder=""
                  @click="$refs.endDateSelectDialog.open(queryParams.endDate)"
                >
                  <template #button>
                    <van-icon name="clear" size="18" @click.stop="queryParams.endDate = ''" style="font-size:16px"/>
                  </template>
                </van-field>
                </van-cell-group>
          </van-collapse-item>

          <van-row style="padding:20px">
                  <van-button round   size="large" type="info" @click="submit" style="height:30px;" >查询</van-button>
                </van-row>
        </van-collapse>

        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 4px',margin:'4px 20px 0px','font-size':'12px','line-height':'18px'}">查询结果共<span style="color:red;margin:4px">{{data.length}}</span>笔</van-divider>

        <van-row style="overflow-y: scroll;padding:0 20px" :style="{ height:height}">
          <van-cell v-for="subWo in data" :key="subWo.woId" title="" style="margin:10px 0">
                <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                <template #label>
                  <van-row>
                    <div class="wrapper">
                    <van-col span="24"><span class="detailTitle">单号:</span> <span class="detailContent">【{{subWo.woId}}】</span></van-col>
                    <van-col span="12"><span class="detailTitle">日期: </span> <span class="detailContent">{{subWo.date}}</span></van-col>
                    <van-col span="12"><span class="detailTitle">品号:</span> <span class="detailContent">{{subWo.productNo}}</span></van-col>
                    
                    <van-col span="12"><span class="detailTitle">单位:</span> <span class="detailContent">{{subWo.unit}}</span></van-col>
                    <van-col span="12"><span class="detailTitle">数量:</span> <span class="detailContent">{{subWo.count}}</span></van-col>
                    <van-col span="24"><span class="detailTitle">规格:</span> <span class="detailContent">{{subWo.spec}}</span></van-col>
                    <van-col span="24"><span class="detailTitle">品名:</span> <span class="detailContent">{{subWo.productName}}</span></van-col>
                  </div>
                    <van-col span="24" style="margin-top:5px">
                      <span class="detailTitle">进度: </span> <span class="detailContent" style="margin-top:10px"><van-progress :percentage="percent(subWo)" /></span>
                    </van-col>
                  </van-row>
                  <van-row>
                    <van-col span="24" style="height:20px;margin-top: 5px;">
                      <span style="position:absolute;color:#1989fa;right:16px;" @click="viewDetail(subWo)">查看详情</span>
                      <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:66px;" name="more" size="16" @click="scan" color="#1989fa"/>
                    </van-col>
                  </van-row>
                </template>
                <template #right-icon>


                </template>
            </van-cell>
        </van-row>
      </div>
      <div v-if ="diplayMode == 'detail'">
        <WoDetail ref="woDetail" @goToList="goToList"></WoDetail>
      </div>

     <DateSelectDialog
      ref="startDateSelectDialog"
      @confirm="(date) => (queryParams.startDate = date)"
    ></DateSelectDialog>

    <DateSelectDialog
      ref="endDateSelectDialog"
      @confirm="(date) => (queryParams.endDate = date)"
    ></DateSelectDialog>
  </div>
</template>

<script>
import { getUserSubWos } from "../../../api/wo";
import { Toast, Dialog } from "vant";
import WoDetail from './woDetail.vue'
import qywxUtil from '../../../util/jweixin/index'
import store from '../../../store/index'
import { router }  from '../../../router'

export default {
  components: {
    Dialog,
    WoDetail
  },
  computed: {
    height(){
        var offH = (this.activeNames.length >0)?10:180;
        var h = window.innerHeight - 400 + offH + 'px';
        return h;
    },
    startDateTimeFormatter() {
      return !this.queryParams.startDate || this.queryParams.startDate == ""
        ? ""
        : this.$dateTimeUtil.formate("YYYY年mm月dd日", this.queryParams.startDate);
    },
    endDateTimeFormatter() {
      return !this.queryParams.endDate || this.queryParams.endDate == ""
        ? ""
        : this.$dateTimeUtil.formate("YYYY年mm月dd日", this.queryParams.endDate);
    },
    text() {
      return this.currentRate.toFixed(0) + '%';
    },
  },
  data() {
    return {
      title: "工单列表",
      queryParams: {
        startDate: "",
        endDate:"",
        woStatus:"未完工"
      },
      diplayMode:"list",
      activeNames:['1'],
      data:[],
      scanWoId:null,
      showDatePicker: false,
      currentRate: 0,
      gradientColor: {
        '0%': '#3fecff',
        '100%': '#6149f6',
      }
    };
  },
  mounted() {
    this.queryParams.endDate = new Date();  

    if('development' != process.env.NODE_ENV)  
      qywxUtil.init();
  },
  methods: {
   async scan(){
      var qrInfo = '';
      try
      {
        
        if(!qywxUtil.isReady){
            Toast.loading({
              message: '系统加载中...',
              forbidClick: true,
              duration:0
              });

              Toast.clear();
            }

            let resp = await qywxUtil.scanQRCode();  
            this.scanWoId = decodeURIComponent(encodeURIComponent(resp.resultStr).replace('%EF%BB%BF',''));
        

        if(this.scanWoId&&this.scanWoId !=''){
          this.viewDetail({
            woId:this.scanWoId
          })
        }
      }
      catch(e){
      }
    },
    viewDetail(subWo){
      this.diplayMode = 'detail';
      this.$nextTick(o=>{
        this.$refs.woDetail.open(subWo);
      })
    },
    submit() {
      /*
      Toast.loading({
          message: '数据加载中...',
          forbidClick: true,
          duration: 0 
      });*/

      getUserSubWos({
        userId:store.state.authorize.user.userNo,
        isFeeding:true,
        woId:this.queryParams.woId,
        productNo:this.queryParams.productNo,
        status:this.queryParams.woStatus,
        startDate:this.queryParams.startDate,
        endDate:this.queryParams.endDate
      }).then(res=>{
        //Toast.clear();
        this.activeNames = [];
        if(res.code == 200) {
          this.data = res.data;
        }
        else{
          this.data = [];
          Dialog.alert({
            message: res.message,
          });
        }
        this.$forceUpdate();
      });
    },
    goToList() {
      this.diplayMode = 'list';
      this.submit();
      //刷新
    },
    goToHomePage() {
      router.push('/home')
    },
    percent(subWo){
        return  subWo.planTotals == 0?0:Math.min(100,Math.round(subWo.finishTotals*100 / subWo.planTotals,0));
    }
  },
};
</script>

<style lang="less" scoped>
.van-radio-group {
  width: 100%;
}
</style>

<style lang="less" scoped>.detailTitle{
  display: inline-block;
  color:black;
  font-size: 15px;
  margin-right: 2px;
  font-weight: 700;
  width:64px;
  text-align-last: justify;
  float:left;
}
.detailContent{
  display: inline-block;
  color:black;
  font-size: 15px;
  font-weight: 300;
  width:calc(100% - 80px);
  float:left;
}

.wrapper div { margin-top:4px;}

  .van-field{
    padding:5px 16px;
  }

  .van-radio--horizontal{
    margin-right:4px;
  }


</style>

<style>
  .van-collapse-item__content
  {
      padding:0;
  }

  .van-collapse-item__wrapper
  {
      margin-top:-12px !important;
    }

    .van-collapse-item__title{
      height:48px;
    }

    .woList .van-cell-group--inset{
    margin-left:0;
    margin-right:0;
    padding-top:5px;
 }

 .van-cell__title{
  font-size:15px;
  font-weight:700;
 }

 .van-radio__label{
  margin-left:4px;
 }
  </style>